import { MessageCircle } from 'lucide-react';
import { InboxLayout } from '@/components/shared-inbox';
import type { InboxPlatformConfig, InboxStore } from '@/components/shared-inbox';
import { useMessengerInboxStore } from '@/stores/useMessengerInboxStore';
import { messengerInboxHooks } from '@/api/messengerInboxAdapters';

const PLATFORM_CONFIG: InboxPlatformConfig = {
    name: 'messenger',
    label: 'Messenger',
    icon: MessageCircle,
    searchPlaceholder: 'Search by name, PSID, business...',
    windowExpiredText: '24h messaging window expired. The user must send a message to reopen.',
    resumeAiBtnVariant: 'blue',
};

export function MessengerInbox() {
    const raw = useMessengerInboxStore();

    const store: InboxStore = {
        selectedConversationId: raw.selectedConversationId,
        showAgentConfig: raw.showAgentConfig,
        setSelectedConversationId: raw.setSelectedConversationId,
        clearSelectedConversationId: raw.clearSelectedConversationId,
        toggleAgentConfig: raw.toggleAgentConfig,
        setShowAgentConfig: raw.setShowAgentConfig,
    };

    return (
        <InboxLayout
            platform={PLATFORM_CONFIG}
            hooks={messengerInboxHooks}
            store={store}
        />
    );
}
